import { DashBoard } from '../pages/dashboard/dashboard';
import ProviderLayout from '../pages/Layout/ProviderLayout';
import MoreDetails from '../pages/moredetails/MoreDetails';
import FacilityMetrics from '../pages/facilitymetrics/FacilityMetrics';
import { Navigate, Route, Routes } from 'react-router-dom';
import ZoomCall from '../pages/moredetails/ZoomCall';
import ZoomCallEnd from '../pages/moredetails/ZoomCallEnd';
import NotFound from '../pages/Layout/NotFound';
import AuthenticationHandler from '../pages/signIn/AuthenticationHandler';
import AccessDenied from '../pages/signIn/Access-denied';

const Routing = () => {
  return (
    <Routes>
      <Route path="/access-denied" element={<AccessDenied />} />
      <Route
        path="/"
        element={
          <AuthenticationHandler>
            <Navigate to="/provider" replace />
          </AuthenticationHandler>
        }
      />
      <Route
        path="/provider/*"
        element={
          <AuthenticationHandler>
            <ProviderLayout />
          </AuthenticationHandler>
        }
      >
        <Route path="consults" element={<DashBoard />} />
        <Route path="details" element={<MoreDetails />} />
        <Route path="metrics" element={<FacilityMetrics />} />
      </Route>

      {/* <Route path="/provider">
          <Route element={<ProviderLayout />}>
            <Route path="consults" element={<DashBoard />} />
            <Route path="details" element={<MoreDetails />} />
            <Route path="metrics" element={<FacilityMetrics />} />
          </Route>
        </Route> */}

      <Route
        path="/zoom-call/:role/:username/:meetingId/:meetingPassword/:caseId/:zoomKey"
        element={
          <AuthenticationHandler>
            <ZoomCall />
          </AuthenticationHandler>
        }
      />
      <Route
        path="/zoom-call-end/:meetingId/:caseId"
        element={
          <AuthenticationHandler>
            <ZoomCallEnd />
          </AuthenticationHandler>
        }
      />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
export default Routing;
